/* sts-jump.js: the one in-page jump (v5.1 PDP-3, PDP-6, GL-1; reuse it for
   the TOC and scroll-to-routine rather than writing another scrollTo).

     STS.jump(target, {focus, done})  land `target` (element or "#id") under
                                the pinned chrome, then focus `focus` (or
                                target); done() once the scroll has settled
     STS.jump.top()             to the top; focus goes to <body>, so the next
                                Tab is the skip link, as on a fresh load
     STS.jump.offset(down)      measured top obstruction + gap, px

   Markup, handled by one delegated listener:
     <a href="#pdp-reviews" data-sts-jump="#sts-reviews-h">  (still a plain
       anchor if this file is missing)
     <button type="button" data-sts-totop>

   Plus the floating Back to top arrow (GL-1). Its own file because
   assets/sts-ui.js is at its AC-29 served ceiling. */
(function (w, d) {
  'use strict';

  var STS = w.STS = w.STS || {};
  if (STS.jump) return;

  var root = d.documentElement;
  /* Set by layout/theme.liquid on product pages. Read now: currentScript is
     only defined while this file first runs. */
  var noArrow = !!(d.currentScript && d.currentScript.hasAttribute('data-no-arrow'));
  var GAP = 16; /* --sts-space-8; the prototype's goReviews used 90 = its 74px header + this */

  function reduced() {
    try { return w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function scrollY() { return w.pageYOffset || root.scrollTop || 0; }
  function pos(el) { return w.getComputedStyle(el).position; }

  /* Measured, not the token: the header's sticky_mode (sections/sts-header.liquid)
     is static (covers nothing), always (pins header + strip) or hide_on_scroll
     (pinned, but slid away on the way DOWN). html's scroll-padding-top in
     assets/sts-tokens.css estimates the pinned case and lands ~180px low at
     390px under today's static header; it stays the fallback for a page with
     no v4 header. */
  function offset(down) {
    var h = d.querySelector('[data-sts-header]');
    if (!h) return parseFloat(w.getComputedStyle(root).scrollPaddingTop) || GAP;
    for (var el = h; el && el !== d.body; el = el.parentElement) {
      var p = pos(el);
      if (p !== 'sticky' && p !== 'fixed') continue;
      var pinned = el.getBoundingClientRect().height;
      if (down && h.getAttribute('data-sts-sticky') === 'hide_on_scroll') pinned -= h.offsetHeight;
      return Math.max(0, pinned) + GAP;
    }
    return GAP;
  }

  /* tabindex=-1 only when missing, removed on blur; theme.css's
     [tabindex="-1"]:focus{outline:none} keeps a ring off a heading or body. */
  function focusOn(el) {
    if (!el || !el.focus) return;
    if (el.tabIndex < 0 && !el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '-1');
      el.addEventListener('blur', function () { el.removeAttribute('tabindex'); }, { once: true });
    }
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* Settled = two samples 80ms apart at the same offset (engines without
     `scrollend` included), capped at 2.5s. */
  function whenStill(cb) {
    var last = -1;
    var still = 0;
    var t0 = Date.now();
    (function tick() {
      var now = scrollY();
      still = now === last ? still + 1 : 0;
      last = now;
      if (still >= 2 || Date.now() - t0 > 2500) cb();
      else w.setTimeout(tick, 80);
    }());
  }

  var run = 0;
  var STOP = ['wheel', 'touchstart', 'keydown'];

  /* `dest` is re-read once the scroll settles and the trip corrected (twice at
     most): a lazy row or app block above the target that grew on the way
     would leave the heading short. A shopper who takes over wins: no
     correction, no focus move. */
  function travel(dest, focusTo, cb) {
    var id = ++run;
    var tries = 0;
    var stopped = false;
    function stop() { stopped = true; }
    function done(ok) {
      STOP.forEach(function (e) { w.removeEventListener(e, stop); });
      if (ok && id === run && focusTo) focusOn(focusTo);
      if (cb) cb(ok);
    }
    STOP.forEach(function (e) { w.addEventListener(e, stop, { passive: true }); });
    (function go() {
      var y = dest();
      var x = w.pageXOffset || 0;
      /* Reduced motion needs 'instant', not 'auto': 'auto' defers to the
         page's CSS, and theme-base.css sets html{scroll-behavior:smooth} for
         everyone, so 'auto' still glided (QA on #586). An engine that rejects
         'instant' throws; it gets the CSS switched off for the one call. */
      if (!reduced()) w.scrollTo({ top: y, left: x, behavior: 'smooth' });
      else {
        try { w.scrollTo({ top: y, left: x, behavior: 'instant' }); } catch (e) {
          root.style.scrollBehavior = 'auto';
          w.scrollTo(x, y);
          root.style.scrollBehavior = '';
        }
      }
      whenStill(function () {
        if (stopped || id !== run) return done(false);
        if (Math.abs(scrollY() - dest()) > 2 && tries++ < 2) return go();
        done(true);
      });
    }());
  }

  function jump(target, opts) {
    var el = typeof target === 'string' ? d.getElementById(target.replace(/^#/, '')) : target;
    if (!el) return false;
    /* Direction fixed up front: on arrival the target is below the top either
       way, and re-reading it would re-aim an upward trip as a downward one. */
    var down = el.getBoundingClientRect().top > 0;
    travel(function () {
      var top = el.getBoundingClientRect().top + scrollY();
      var max = Math.max(0, root.scrollHeight - w.innerHeight);
      return Math.min(max, Math.max(0, Math.round(top - offset(down))));
    }, (opts && opts.focus) || el, opts && opts.done);
    return true;
  }

  function top() { travel(function () { return 0; }, d.body); }

  jump.top = top;
  jump.offset = offset;
  STS.jump = jump;

  d.addEventListener('click', function (ev) {
    if (ev.defaultPrevented || ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var el = ev.target && ev.target.closest && ev.target.closest('[data-sts-jump],[data-sts-totop]');
    if (!el) return;
    if (el.hasAttribute('data-sts-totop')) {
      ev.preventDefault();
      top();
      return;
    }
    var href = el.getAttribute('href') || '';
    var dest = href.charAt(0) === '#' && href.length > 1 && d.getElementById(href.slice(1));
    if (!dest) return; /* no target here: leave it to the browser */
    ev.preventDefault();
    var f = null;
    try { f = d.querySelector(el.getAttribute('data-sts-jump')); } catch (e) { /* empty or not a selector */ }
    jump(dest, { focus: f || dest });
  });

  // ---------------------------------------------- floating arrow (GL-1)

  /* Prototype v6 §1.2: a 48px white circle with an up arrow, 16px from the
     right edge, 24px up on desktop and 15px above the bottom menu on a phone
     (--sts-bottom-offset, assets/sts-bottom-nav.css; 61 + 15 = the
     prototype's 76px, v6.1 1.5: a bubble keeps a gap), fading in past 600px of
     scroll. The rules ship with the script: the arrow only exists once this
     runs, so no render-blocking sheet (or the AC-29 tokens+components layer)
     pays for it. --sts-totop-lift is written by probe() below. */
  var CSS = '.sts-totop{position:fixed;z-index:47;right:16px;' +
    'bottom:calc(var(--sts-bottom-offset,env(safe-area-inset-bottom,0px)) + 24px + var(--sts-totop-lift,0px));' +
    'display:flex;align-items:center;justify-content:center;box-sizing:border-box;' +
    'width:48px;height:48px;margin:0;padding:0;border-radius:50%;border:1.5px solid #DBDCDD;background:#fff;color:#2F3572;' +
    'font:600 20px/1 var(--sts-font,inherit);box-shadow:0 10px 26px rgba(30,33,64,.16);cursor:pointer;' +
    '-webkit-tap-highlight-color:transparent;opacity:0;visibility:hidden;transform:translateY(8px);' +
    'transition:opacity .2s ease,transform .2s ease,visibility .2s ease}' +
    '.sts-totop[data-shown="true"]{opacity:1;visibility:visible;transform:none}' +
    '.sts-totop:hover{border-color:#2F3572}' +
    '.sts-totop:focus-visible{outline:3px solid #2F3572;outline-offset:2px}' +
    'html[data-sts-chrome-open] .sts-totop,html[data-sts-drawer="open"] .sts-totop{opacity:0;visibility:hidden}' +
    '@media (max-width:860px){.sts-totop{bottom:calc(var(--sts-bottom-offset,env(safe-area-inset-bottom,0px)) + 15px + var(--sts-totop-lift,0px))}}' +
    '@media (prefers-reduced-motion:reduce){.sts-totop{transition:none;transform:none}}' +
    '@media print{.sts-totop{display:none}}';

  /* v6 §1.2: hidden while the Skin Profile selection bar or the Personalize
     save bar is on screen; they own the bottom of the page then. */
  var BARS = '[data-sts-el="sticky"],.sts-pz__save';

  function arrow() {
    /* Not on product pages (v6 §1.2): layout/theme.liquid marks the script
       there, and any page whose sticky bar has its own Back to top counts too. */
    if (noArrow || d.querySelector('[data-sts-sticky] [data-sts-totop]')) return;

    var btn = null;
    var shown = false;
    var blocked = false;
    var lift = 0;
    var frame = 0;
    var probed = 0;

    function make() {
      var style = d.createElement('style');
      style.textContent = CSS;
      d.head.appendChild(style);
      btn = d.createElement('button');
      btn.type = 'button';
      btn.className = 'sts-totop';
      btn.setAttribute('data-sts-totop', '');
      btn.setAttribute('aria-label', 'Back to top');
      btn.textContent = '↑';
      d.body.appendChild(btn);
    }

    function barUp() {
      var list = d.querySelectorAll(BARS);
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (!list[i].hidden && r.height && r.bottom > 0 && r.top < w.innerHeight) return true;
      }
      return false;
    }

    /* Never on another floating control. A small fixed (or bottom-sticky)
       element under the arrow's corner (the chat launcher: Gorgias today,
       Voiceflow in a shadow root, hence the second lookup) lifts it 12px
       clear. A full-width bar there, or a tall FIXED element (the chat window,
       the cart drawer, a sheet), hides it; a tall sticky one is a content
       column and is ignored. Sampled at the un-lifted spot so the answer holds
       once lifted; every 300ms at most, only while wanted. */
    function probe() {
      var now = Date.now();
      if (now - probed < 300) return;
      probed = now;
      var r = btn.getBoundingClientRect();
      var bottom = r.bottom + lift;
      var vh = w.innerHeight;
      var need = 0;
      var tall = false;
      function check(el) {
        if (el === btn || btn.contains(el) || el === root || el === d.body) return;
        var p = pos(el);
        if (p !== 'fixed' && p !== 'sticky') return;
        var fr = el.getBoundingClientRect();
        if (fr.height > vh * 0.5) { if (p === 'fixed') tall = true; return; }
        if (fr.width > w.innerWidth * 0.6) { tall = true; return; }
        need = Math.max(need, bottom - fr.top + 12);
      }
      [[r.left + 3, bottom - 3], [r.right - 3, bottom - 3], [r.left + r.width / 2, bottom - r.height / 2],
        [r.left + 3, bottom - r.height + 3], [r.right - 3, bottom - r.height + 3]].forEach(function (pt) {
        (d.elementsFromPoint ? d.elementsFromPoint(pt[0], pt[1]) : []).forEach(function (el) {
          check(el);
          if (el.shadowRoot && el.shadowRoot.elementsFromPoint) el.shadowRoot.elementsFromPoint(pt[0], pt[1]).forEach(check);
        });
      });
      blocked = tall || need > vh * 0.5;
      if (need !== lift) {
        lift = need;
        btn.style.setProperty('--sts-totop-lift', need + 'px');
      }
    }

    function update() {
      frame = 0;
      var want = scrollY() > 600;
      if (want && !btn) make();
      if (!btn) return;
      if (want) probe();
      want = want && !blocked && !barUp();
      if (want !== shown) {
        shown = want;
        btn.setAttribute('data-shown', String(want));
      }
    }

    function schedule() { if (!frame) frame = w.requestAnimationFrame(update); }
    w.addEventListener('scroll', schedule, { passive: true });
    w.addEventListener('resize', function () { probed = 0; schedule(); });
    /* The selection bar and the save bar come and go on a tap, not a scroll. */
    d.addEventListener('click', function () { w.setTimeout(schedule, 60); });
    update();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', arrow);
  else arrow();
}(window, document));
